import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import type { ConfiguredLanguage } from '@/app/permissions/permissionHelpers'

export interface UsersLanguageFieldProps {
  languages: ConfiguredLanguage[]
  value: string
  onChange: (v: string) => void
  disabled?: boolean
}

export function UsersLanguageField({
  languages,
  value,
  onChange,
  disabled,
}: UsersLanguageFieldProps) {
  if (languages.length < 2) return null

  const defaultLang = languages.find((l) => l.isDefault) ?? languages[0]
  const defaultName = defaultLang.name

  return (
    <Select
      data-testid="users-language"
      value={value}
      onChange={(e) => onChange(String(e.target.value))}
      disabled={disabled}
      displayEmpty
      size="small"
      fullWidth
    >
      <MenuItem value="">Default — {defaultName}</MenuItem>
      {languages.map((lang) => (
        <MenuItem key={lang.code} value={lang.code}>
          {lang.name}
        </MenuItem>
      ))}
    </Select>
  )
}
